export default "__VITE_ASSET__Cap8PYjK__"